import { Component, Input } from '@angular/core';
import {
  AppIcon,
  AppIconColor,
  AppIconSize,
  FrontendIconsModule,
} from '@tablesready/frontend-icons';

import { NgIf } from '@angular/common';
import { PartyTypes } from '@shared/party';
import { getPartyExpectedEnd } from '@shared/party/functions';
import { PipesModule } from '@tablesready/common-ui';
import { FloorPlanPartyType } from '../get-party-type';

@Component({
  selector: 'tablesready-table-time',
  templateUrl: './table-time.component.html',
  styleUrls: ['./table-time.component.scss'],
  standalone: true,
  imports: [
    FrontendIconsModule,
    NgIf,
    PipesModule,
  ],
})
export class TableTimeComponent {
  @Input() type = FloorPlanPartyType.booked;
  @Input() quotedTime = 0;
  @Input() seatedTime = 0;
  @Input() checkInTime = 0;
  @Input() canceledTime = 0;
  @Input() duration = 0;
  @Input() colorClass = 'time-light';
  @Input() iconColor = AppIconColor.primary;
  @Input() timezone = '';
  /** Reservations end at their booked time; walk-ins end a duration after they sat. */
  @Input() isReservation = false;

  icon = AppIcon;
  size = AppIconSize;
  floorPlanPartyType = FloorPlanPartyType;

  /**
   * Shared expected-end rule, so this panel can't contradict the floor-plan card it is
   * embedded in (the card header reads the same helper for its "ends" copy).
   */
  get expectedEndTime(): number {
    return getPartyExpectedEnd({
      type: this.isReservation ? PartyTypes.reservation : PartyTypes.walkIn,
      quoted_time: this.quotedTime,
      seated_time: this.seatedTime || null,
      duration: this.duration,
    });
  }
}
